interface PickedStationObject {
  stationId?: unknown;
  properties?: {
    id?: unknown;
    selectionId?: unknown;
  };
}

/** Resolve a picked deck object to the stable ID used by station extents. */
export function pickedStationId(
  layerId: string | undefined,
  object: unknown,
): string | undefined {
  if (typeof object !== 'object' || object === null) return undefined;
  const picked = object as PickedStationObject;
  if (layerId === 'subwayStationExtents') {
    return typeof picked.stationId === 'string' ? picked.stationId : undefined;
  }
  if (layerId !== 'subwayStations') return undefined;
  const id = picked.properties?.selectionId ?? picked.properties?.id;
  return typeof id === 'string' ? id : undefined;
}
